import React, { useState, useEffect } from "react";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import Header from "../../../commons/Header/Header";
import { useLocation } from "react-router-dom";
import TermsAndConditions from "../Customer/TermsAndConditions";
import PrivacyPolicy from "../Customer/PrivacyPolicy";
import "notosans-fontface/css/notosans-fontface.css";

function Customer() {
  const location = useLocation();
  const [cms, setCms] = useState({
    type: "terms_and_conditions",
  });
  useEffect(() => {
    if (location?.state) {
      setCms({ type: location.state });
    }
  }, [location.state]);

  return (
    <>
      <div className="main-panel">
        <div className="content-wrapper pt-2 px-0">
          <div className="row mx-0 main-content-body">
            <div className="col-md-12 mb-26 px-0 mt-2">
              <ul className="nav common-tabs cms-tabs w-100" id="myTab" role="tablist">
                <li className="nav-item ">
                  <a
                    className={`nav-link br-10 w-auto text-center ml-0 ${cms.type === "terms_and_conditions" ? "active" : undefined}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setCms({ type: "terms_and_conditions" })}
                  >
                    Terms And Conditions
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link br-10 w-auto text-center ${cms.type === "privacy_policy" ? "active" : undefined}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setCms({ type: "privacy_policy" })}
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-12 tab-content row px-0 mx-0">
              {cms.type === "terms_and_conditions" ? <TermsAndConditions role="User" /> : cms.type === "privacy_policy" ? <PrivacyPolicy role="User" /> : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Customer;
